"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarFactoryFromJS = void 0;
const core_1 = require("@bimser/core");
const calendars_1 = require("../entities/calendars");
const enums_1 = require("../enums");
function calendarFactoryFromJS(calendar) {
    if (calendar && !(0, core_1.isNullOrUndefined)(calendar.type)) {
        switch (calendar.type) {
            case enums_1.ECalendarType.Cron:
                return (0, calendars_1.CronCalendarFactoryFromJS)(calendar);
            case enums_1.ECalendarType.Daily:
                return (0, calendars_1.DailyCalendarFactoryFromJS)(calendar);
            case enums_1.ECalendarType.Holiday:
                return (0, calendars_1.HolidayCalendarFactoryFromJS)(calendar);
            case enums_1.ECalendarType.Monthly:
                return (0, calendars_1.MonthlyCalendarFactoryFromJS)(calendar);
            case enums_1.ECalendarType.Weekly:
                return (0, calendars_1.WeeklyCalendarFactoryFromJS)(calendar);
            case enums_1.ECalendarType.Annual:
                return (0, calendars_1.AnnualCalendarFactoryFromJS)(calendar);
        }
    }
}
exports.calendarFactoryFromJS = calendarFactoryFromJS;
//# sourceMappingURL=calendarFactoryFromJS.js.map